document.addEventListener("DOMContentLoaded", function () {
    const switch_darkmode_footer = document.getElementById('switch_darkmode_footer');
    const switch_darkmode_header = document.getElementById('switch_darkmode_header');

    function dark_mode_toggle(checked, register = true) {
        const expiration_date = new Date();
        expiration_date.setFullYear(expiration_date.getFullYear() + 1);

        switch_darkmode_footer.checked = checked;
        switch_darkmode_header.checked = checked;

        if (checked) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }

        if(register) {
            document.cookie = 'blog_alice_dark_mode=' + checked + '; expires=' + expiration_date.toUTCString() + '; path=/';
        }
    }

    function dark_mode_check() {
        if (cookie_exists('blog_alice_dark_mode', 'true') === true) {
            dark_mode_value = true;
        } else if(cookie_exists('blog_alice_dark_mode', 'false') === true) {
            dark_mode_value = false;
        } else {
            if(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                dark_mode_value = true;
            } else {
                dark_mode_value = false;
            }
        }

        dark_mode_toggle(dark_mode_value, false);
    }

    switch_darkmode_footer.addEventListener('change', function () {
        dark_mode_toggle(switch_darkmode_footer.checked);
    });

    switch_darkmode_header.addEventListener('change', function () {
        dark_mode_toggle(switch_darkmode_header.checked);
    });

    dark_mode_check();
});